export const SET_MAP_LEGEND_SHOW = 'SET_MAP_LEGEND_SHOW';
export const TOGGLE_MAP_LEGEND_SHOW = 'TOGGLE_MAP_LEGEND_SHOW';

export const setMapLegendShow = (isMapLegendVisible: boolean) => ({
    type: SET_MAP_LEGEND_SHOW,
    isMapLegendVisible,
});

export const toggleMapLegendShow = () => ({
    type: TOGGLE_MAP_LEGEND_SHOW,
});